import { Database } from "lucide-react";

import { cn } from "@hero-app/lib/utils";
import type { TableColumn, TableRow } from "./table-data";

export function TableCell({ column, row }: { column: TableColumn; row: TableRow }) {
  const align = column.align === "right" ? "text-right" : "text-left";
  const value = row[column.id as keyof TableRow];

  if (column.variant === "credits") {
    return (
      <span
        className={cn(
          "inline-flex items-center gap-0.5 text-[11px] font-medium tracking-[-0.4px] text-black/50",
          align,
        )}
      >
        <Database className="size-2.5 shrink-0" />
        {value}
      </span>
    );
  }

  return (
    <span
      className={cn(
        "text-[11px] font-medium tracking-[-0.4px] text-black/50",
        align,
        column.id === "name" && "truncate",
      )}
    >
      {value}
    </span>
  );
}
